import { Link, useLocation } from "react-router-dom";
import styles from "./Nav.module.css";
import logoSrc from "../images/logo.svg";

export default function Nav({ theme = "dark" }) {
  const { pathname } = useLocation();

  return (
    <nav className={`${styles.nav} ${styles[theme]}`}>
      <Link to="/" className={styles.logo}>
        <img src={logoSrc} alt="Maggie Cody logo" width="30" height="30" />
        <span className={styles.logoName}>Maggie Cody</span>
      </Link>
      <div className={styles.links}>
        <Link to="/" className={pathname === "/" ? styles.active : ""}>
          home
        </Link>
        <Link
          to="/writing"
          className={pathname === "/writing" ? styles.active : ""}
        >
          writing
        </Link>
        <Link
          to="/resume"
          className={pathname === "/resume" ? styles.active : ""}
        >
          resume
        </Link>
      </div>
    </nav>
  );
}
